import { Box } from '@mui/material';
import { Routes, Route } from 'react-router-dom';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import RouteWithTitle from '../../../routes/RouteWithTitle';

import DownloadSettings from './downloadSettings/DownloadSettings';
import Limitation from './limitationSettings/Limitation';

export const DataDownloadSettingsChildRoutes = () => (
  <Routes>
    <Route
      path="/data-download"
      element={
        <RouteWithTitle title="Data Download Settings - Wisestep">
          <DownloadSettings />
        </RouteWithTitle>
      }
    />
    <Route
      path="/limitation"
      element={
        <RouteWithTitle title="">
          <Limitation />
        </RouteWithTitle>
      }
    />
  </Routes>
);

const DataDownloadSettings = () => {
  return (
    <SettingsPageLayout
      title="Data Download Settings"
      indexOptions={[
        { label: 'Attribute settings', url: '/download-settings/data-download' },
        { label: 'Download Limit', url: '/download-settings/limitation' },
      ]}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.CRM,
        Pages['DATA_DOWNLOAD_SETTING']
      )}
    >
      <Box component="form" px={8} pt={2}>
        <DataDownloadSettingsChildRoutes />
      </Box>
    </SettingsPageLayout>
  );
};

export default DataDownloadSettings;
